import { PrimaryButton } from '@client/new/components/button';
import { navigate, PATHS } from '@client/routes';
import { useCallback, useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { Link } from 'react-router';
import { useLoginStore } from '../../../stores/login.store';
import { useSignUpStore } from '../../../stores/sign-up.store';
import { AuthLayout } from '../auth.layout';
import { TextField, Typography } from '@mui/material';
import { trackEvent, track } from '@services/tracking';
import { initMetaPixelTracking, tryStoreSourceURL } from '@services/meta-pixel';
import { initHubspot, trackSubmission } from '@services/hubspot/HubspotService';

export const SignUpPage = () => {
  const { setEmail: setLoginEmail } = useLoginStore();
  const { email, setEmail } = useSignUpStore();
  const { register, handleSubmit, watch } = useForm({
    defaultValues: { email },
  });

  useEffect(() => {
    initHubspot();
    tryStoreSourceURL();
    initMetaPixelTracking();
    track({ type: 'Sign Up', payload: { uid: '' } });
  }, []);

  const onSubmit = useCallback(async (values: { email: string }) => {
    track({
      type: 'Email Submitted',
      payload: { uid: '' },
    });
    trackEvent({
      type: 'Email Submitted',
      payload: { email: values.email } as any,
    });
    setEmail(values.email);
    setLoginEmail(values.email);
    navigate(PATHS.SIGN_UP_FILL_NAME);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const completed = watch('email')?.length;

  return (
    <AuthLayout title={'Start creating on Playbook ⚡️'} showGoBack>
      <div className="flex flex-col items-center">
        <form
          className="mt-8 w-full flex flex-col items-center text-left"
          onSubmit={handleSubmit(onSubmit)}
        >
          <div className="w-full">
            <TextField
              aria-label="Email address"
              type="email"
              required
              className="w-full"
              placeholder="Type your email"
              {...register('email', { required: true })}
            />
            <Typography variant="subtitle2">
              This email will be used to log in. No password needed.
            </Typography>
          </div>
          <Typography variant="subtitle2" className="mt-8 font-bold">
            By signing up, you agree to our{' '}
            <a
              className="link-inline"
              href="https://playbookapp.io/privacy-policy"
              target="_blank"
              rel="noreferrer"
            >
              Privacy Policy
            </a>{' '}
            and{' '}
            <a
              className="link-inline"
              href="https://playbookapp.io/terms-of-use"
              target="_blank"
              rel="noreferrer"
            >
              Term of Use
            </a>
            {'.'}
          </Typography>
          <div className="w-full mt-5 max-w-md">
            <PrimaryButton
              className="w-full"
              type="submit"
              disabled={!completed}
            >
              Agree and continue
            </PrimaryButton>
          </div>
        </form>

        <Typography
          variant="subtitle2"
          className="absolute md:block bottom-20 mt-10 font-bold"
        >
          <span>Already have an account?</span>{' '}
          <Link className="link" to={'/login'}>
            Sign in
          </Link>
        </Typography>
      </div>
    </AuthLayout>
  );
};
